import {useRouter} from 'next/router'
import {Panel} from '@components/Panel'
import {VStack, HStack, Spacer} from '@components/Stack'
import {Text} from '@components/Text'
import Image from 'next/image'
import {Button} from 'src/Button'
import {Icon} from 'src/Icon'
import styles from 'src/Learn.module.css'
import {sendEvent} from 'src/analytics'

export const CourseTile = ({
  id,
  image,
  title,
  description,
  stats,
  isAvailable = false,
  disabled = false,
  vendorId,
  demoLink,
  onPlay,
  onBuy,
  comingSoonText,
  glowing,
  tag,
  nonDiscountedPrice,
  isPurchaseInProgress,
}) => {
  const router = useRouter()
  return (
    <div className={styles.courseTile}>
      <Panel fullWidth fullHeight padding="0.75rem" glowing={glowing}>
        <VStack gap="1rem" align="initial" fullHeight>
          <div className={styles.courseImageWrap}>
            {/* <img className={styles.courseImage} src={image} width="100%" /> */}
            <Image
              src={image}
              alt={title}
              width={100}
              layout="fill"
              className={styles.courseImage}
            />
          </div>

          {tag ? (
            <div
              className="animate__tada"
              style={{
                position: 'absolute',
                right: '1.3rem',
                top: '1.3rem',
                background: '#334',
                color: 'black',
                padding: '0.4rem 0.7rem',
                borderRadius: '0.5rem',
              }}
            >
              {tag}
            </div>
          ) : null}

          <div style={{padding: ' 0.5rem 0.75rem 0.75rem', height: '100%'}}>
            <VStack gap="1.5rem" justify="space-between" fullHeight>
              <VStack gap="0.5rem" align="center">
                <Text mono={false} size={3} weight={600} appearance="heading">
                  {title}
                </Text>
                <Text
                  mono={false}
                  size={1}
                  weight={500}
                  appearance="tertiary"
                  align="center"
                >
                  {description}
                </Text>
              </VStack>

              <div style={{width: '100%'}}>
                <VStack gap="0.5rem" align="stretch">
                  {stats ? (
                    <div>{stats}</div>
                  ) : (
                    <div className={styles.comingSoon}>
                      <Text
                        mono={false}
                        weight={500}
                        size={0}
                        appearance="tertiary"
                      >
                        {comingSoonText || 'Coming soon!'}
                      </Text>
                    </div>
                  )}

                  <VStack gap="0.5rem" align="flex-start">
                    {/* {isAvailable && (
                    <div>
                      <a
                        href={demoLink}
                        className="link"
                        target="_blank"
                        rel="noopener"
                      >
                        Have a look
                      </a>
                    </div>
                  )} */}
                  </VStack>

                  <HStack gap="0.5rem">
                    {demoLink && !onPlay && (
                      <Button
                        onClick={() => {
                          sendEvent({name: 'courseDemoBtnClicked', label: id})
                          router.push(demoLink)
                        }}
                      >
                        Demo
                      </Button>
                    )}

                    <Button
                      primary={!onPlay && isAvailable}
                      disabled={disabled || isPurchaseInProgress}
                      onClick={onPlay ? onPlay : onBuy}
                      extraClasses={`action-button button--full-width ${
                        onPlay ? 'button--cssbattle' : ''
                      }`}
                      isLoading={isPurchaseInProgress}
                    >
                      {(() => {
                        if (isPurchaseInProgress) {
                          return 'Finishing up...'
                        }
                        if (onPlay) {
                          return "Let's Learn!"
                        } else if (isAvailable) {
                          return (
                            <HStack gap="0.3rem" align="center">
                              <span>Buy for </span>
                              <span
                                className="paddle-net"
                                data-product={vendorId}
                                style={{
                                  fontFamily: 'var(--font-mono)',
                                }}
                              >
                                ...
                              </span>
                              {nonDiscountedPrice ? (
                                <span
                                  className="striked-out"
                                  data-product={vendorId}
                                  style={{
                                    fontFamily: 'var(--font-mono)',
                                  }}
                                >
                                  {nonDiscountedPrice}
                                </span>
                              ) : null}
                            </HStack>
                          )
                        } else {
                          return 'Notify Me'
                        }
                      })()}
                    </Button>
                  </HStack>
                </VStack>
              </div>
            </VStack>
          </div>
        </VStack>
      </Panel>
    </div>
  )
}
